 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AssetCreate":"AssetCreate","AssetDetail":"AssetDetail","AssetEdit":"AssetEdit","AssetLayout":"AssetLayout","AssetsIndex":"AssetsIndex","BrandDescribeEdit~BrandDetailEdit":"BrandDescribeEdit~BrandDetailEdit","BrandDescribeEdit":"BrandDescribeEdit","BrandDetailEdit":"BrandDetailEdit","BrandDescribe~BrandDetail~Dashboard":"BrandDescribe~BrandDetail~Dashboard","BrandDescribe":"BrandDescribe","BrandDetail":"BrandDetail","Dashboard":"Dashboard","BrandLayout":"BrandLayout","BrandList":"BrandList","BrandSettings":"BrandSettings","Calendar":"Calendar","CompanyInfo":"CompanyInfo","CompleteRegistration":"CompleteRegistration","ForgotPassword":"ForgotPassword","InterfaceSettings":"InterfaceSettings","InterfaceSettingsButtons":"InterfaceSettingsButtons","InterfaceSettingsColors":"InterfaceSettingsColors","InterfaceSettingsFonts":"InterfaceSettingsFonts","InterfaceSettingsLoginScreen":"InterfaceSettingsLoginScreen","InterfaceSettingsNavigation":"InterfaceSettingsNavigation","Login":"Login","Metrics":"Metrics","MetricsLayout":"MetricsLayout","ProfileInfo":"ProfileInfo","ProfileLayout":"ProfileLayout","SettingsLayout":"SettingsLayout","Shared":"Shared","SignUp":"SignUp","UpdateLayout":"UpdateLayout","Updates":"Updates","Users":"Users","VerifyPassword":"VerifyPassword"}[chunkId]||chunkId) + "." + {"AssetCreate":"c38b0aec","AssetDetail":"9fd29a8f","AssetEdit":"5324015c","AssetLayout":"989f807b","AssetsIndex":"6e90d47a","BrandDescribeEdit~BrandDetailEdit":"f90b7b59","BrandDescribeEdit":"103bd065","BrandDetailEdit":"d6a158cf","BrandDescribe~BrandDetail~Dashboard":"6947b524","BrandDescribe":"04bab986","BrandDetail":"f530b8c1","Dashboard":"1b15eb46","BrandLayout":"256f4c5e","BrandList":"40707223","BrandSettings":"7857cc8f","Calendar":"3b0e701a","CompanyInfo":"0a5c1c0c","CompleteRegistration":"2bd1a131","ForgotPassword":"fd171cac","InterfaceSettings":"4c9af90f","InterfaceSettingsButtons":"dec0f512","InterfaceSettingsColors":"c48c32d5","InterfaceSettingsFonts":"64913b61","InterfaceSettingsLoginScreen":"97d4574a","InterfaceSettingsNavigation":"49181ad0","Login":"af5d0f93","Metrics":"7aa0e638","MetricsLayout":"e05f1c97","ProfileInfo":"2928a0ef","ProfileLayout":"07123db8","SettingsLayout":"633cf5ea","Shared":"26e035f0","SignUp":"ee6e88f0","UpdateLayout":"773a5d38","Updates":"c76ba17d","Users":"9cce7e65","VerifyPassword":"f841d7c3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AssetCreate":1,"AssetDetail":1,"AssetEdit":1,"AssetLayout":1,"AssetsIndex":1,"BrandDescribeEdit~BrandDetailEdit":1,"BrandDetailEdit":1,"BrandDescribe~BrandDetail~Dashboard":1,"BrandDescribe":1,"BrandLayout":1,"BrandList":1,"BrandSettings":1,"Calendar":1,"CompanyInfo":1,"InterfaceSettingsButtons":1,"ProfileInfo":1,"SignUp":1,"Updates":1,"Users":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AssetCreate":"AssetCreate","AssetDetail":"AssetDetail","AssetEdit":"AssetEdit","AssetLayout":"AssetLayout","AssetsIndex":"AssetsIndex","BrandDescribeEdit~BrandDetailEdit":"BrandDescribeEdit~BrandDetailEdit","BrandDescribeEdit":"BrandDescribeEdit","BrandDetailEdit":"BrandDetailEdit","BrandDescribe~BrandDetail~Dashboard":"BrandDescribe~BrandDetail~Dashboard","BrandDescribe":"BrandDescribe","BrandDetail":"BrandDetail","Dashboard":"Dashboard","BrandLayout":"BrandLayout","BrandList":"BrandList","BrandSettings":"BrandSettings","Calendar":"Calendar","CompanyInfo":"CompanyInfo","CompleteRegistration":"CompleteRegistration","ForgotPassword":"ForgotPassword","InterfaceSettings":"InterfaceSettings","InterfaceSettingsButtons":"InterfaceSettingsButtons","InterfaceSettingsColors":"InterfaceSettingsColors","InterfaceSettingsFonts":"InterfaceSettingsFonts","InterfaceSettingsLoginScreen":"InterfaceSettingsLoginScreen","InterfaceSettingsNavigation":"InterfaceSettingsNavigation","Login":"Login","Metrics":"Metrics","MetricsLayout":"MetricsLayout","ProfileInfo":"ProfileInfo","ProfileLayout":"ProfileLayout","SettingsLayout":"SettingsLayout","Shared":"Shared","SignUp":"SignUp","UpdateLayout":"UpdateLayout","Updates":"Updates","Users":"Users","VerifyPassword":"VerifyPassword"}[chunkId]||chunkId) + "." + {"AssetCreate":"b5ef27dc","AssetDetail":"83b4dae8","AssetEdit":"0f5b22e5","AssetLayout":"30964f5c","AssetsIndex":"7300de5d","BrandDescribeEdit~BrandDetailEdit":"119f9585","BrandDescribeEdit":"31d6cfe0","BrandDetailEdit":"7920859c","BrandDescribe~BrandDetail~Dashboard":"2e1b47ff","BrandDescribe":"b2dfa14b","BrandDetail":"31d6cfe0","Dashboard":"31d6cfe0","BrandLayout":"843c9a91","BrandList":"33840a3e","BrandSettings":"56a18d63","Calendar":"9d81bf40","CompanyInfo":"788cbac5","CompleteRegistration":"31d6cfe0","ForgotPassword":"31d6cfe0","InterfaceSettings":"31d6cfe0","InterfaceSettingsButtons":"44de25e9","InterfaceSettingsColors":"31d6cfe0","InterfaceSettingsFonts":"31d6cfe0","InterfaceSettingsLoginScreen":"31d6cfe0","InterfaceSettingsNavigation":"31d6cfe0","Login":"31d6cfe0","Metrics":"31d6cfe0","MetricsLayout":"31d6cfe0","ProfileInfo":"12b8e957","ProfileLayout":"31d6cfe0","SettingsLayout":"31d6cfe0","Shared":"31d6cfe0","SignUp":"b4ca687f","UpdateLayout":"31d6cfe0","Updates":"8a1632aa","Users":"906785d0","VerifyPassword":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
